import React, { Component } from 'react'
import Markup from './stage-markup'

class stage extends Component {
  constructor () {
    super()
    this.state = {
      crop: 'center',
      value: 'bottom-left',
      media: 'image',
      scroller: '',
      mlHeadline: false,
      noBackground: false,
    }

    this.handleOptChange = this.handleOptChange.bind(this);
  }

  handleOptChange (event, stateName) {
    stateName === 'crop' && this.setState({ crop: event.target.value });
    stateName === 'media' && this.setState({ media: event.target.value });
    stateName === 'value' && this.setState({ value: event.target.value });
    stateName === 'scroller' && this.setState({ scroller: event.target.value });
    stateName === 'mlHeadline' && this.setState({ mlHeadline: !this.state.mlHeadline });
    stateName === 'noBackground' && this.setState({ noBackground: !this.state.noBackground });
  }

  render () {
    return (
      <div>
        <section className='container'>
          <div className='row'>
            <div className='col-md-4'>
              <h6>Select an option:</h6>
              <label>
                <input type='checkbox' onChange={(e) => this.handleOptChange(e, 'mlHeadline')} />
                &nbsp; Multi line padded text
              </label>
              <label>
                <input type='checkbox' onChange={(e) => this.handleOptChange(e, 'noBackground')} />
                &nbsp; Content w/o background colors
              </label>
              <br />
              <br />
            </div>

            <div className='col-md-4'>
              <h6>Select a media source:</h6>
              <select value={this.state.media} onChange={(e) => this.handleOptChange(e, 'media')}>
                <option value='image'>Background image</option>
                <option value='video'>Background video</option>
              </select>
              <br />
              <br />
            </div>

            <div className='col-md-4'>
              <h6>Select a content position:</h6>
              <select value={this.state.value} onChange={(e) => this.handleOptChange(e, 'value')}>
                <option value='bottom-left'>Bottom-left</option>
                <option value='bottom-center'>Bottom-center</option>
                <option value='bottom-right'>Bottom-right</option>
                <option value='centered'>Centered</option>
                <option value='top-left'>Top-left</option>
                <option value='top-center'>Top-center</option>
                <option value='top-right'>Top-right</option>
              </select>
              <br />
              <br />
            </div>

            <div className='col-md-4'>
              <h6>Select a media cropping:</h6>
              <select value={this.state.crop} onChange={(e) => this.handleOptChange(e, 'crop')}>
                <option value='center'>Center</option>
                <option value='left'>Left</option>
                <option value='right'>Right</option>
              </select>
              <br />
              <br />
            </div>

            <div className='col-md-4'>
              <h6>Select a scroll indicator:</h6>
              <select value={this.state.scroller} onChange={(e) => this.handleOptChange(e, 'scroller')}>
                <option value='-'>No scroll indicator</option>
                <option value='scroller'>White scroll indicator</option>
                <option value='scroller-dark'>Dark scroll indicator</option>
              </select>
              <br />
              <br />
            </div>
          </div>
        </section>

        <br />
        <br />

        <section>
          <Markup
            theme={this.state.theme}
            crop={this.state.crop}
            position={this.state.value}
            media={this.state.media}
            scroller={this.state.scroller}
            multiline={this.state.mlHeadline}
            noBackground={this.state.noBackground}
          />
        </section>
      </div>
    )
  }
}

export default stage;



// WEBPACK FOOTER //
// ./catalog/stage/stage.js